import { render, staticRenderFns } from "./goFlexDetail.vue?vue&type=template&id=83e68b3c"
import script from "./goFlexDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./goFlexDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports